import { EventEmitter } from '../util/eventemitter';

let iop: any = null;
const socketList: any[] = [];
let initialized = false;

// Initialize Socket.IO connection and event listeners
function initializeSocketIO() {
  if (initialized) return;
  initialized = true;

  iop = io();

  iop.on('tc', function(sockIdx: number) {
    socketList[sockIdx].emit('connect');
  });
  iop.on('tp', function(sockIdx: number, data: any) {
    socketList[sockIdx].emit('data', new Uint8Array(data));
  });
  iop.on('tx', function(sockIdx: number) {
    socketList[sockIdx].emit('end');
  });
}

// config.transport === 'ws': talk to the game servers over WebSocket via the
// web server at /ws/<port> (the host in the server's packet is ignored).
// Otherwise use the socket.io TCP relay served by client/app.ts (dev).
const useWebSocket = () => config.transport === 'ws';

export class RSocket extends EventEmitter {
  index: number;
  ws: WebSocket | null = null;

  constructor() {
    super();

    this.index = socketList.length;
    socketList.push(this);
  }

  connect(host: string, port: number) {
    if (useWebSocket()) {
      const scheme = location.protocol === 'https:' ? 'wss' : 'ws';
      const ws = (this.ws = new WebSocket(`${scheme}://${location.host}/ws/${port}`));
      ws.binaryType = 'arraybuffer';
      ws.onopen = () => this.emit('connect');
      ws.onmessage = (e) => this.emit('data', new Uint8Array(e.data));
      ws.onclose = () => this.emit('end');
      return;
    }
    initializeSocketIO();
    iop.emit('tc', this.index, host, port);
  }

  send(data: any) {
    if (this.ws) {
      this.ws.send(data);
      return;
    }
    initializeSocketIO();
    iop.emit('tp', this.index, data);
  }

  end() {
    if (this.ws) {
      this.ws.close();
      return;
    }
    initializeSocketIO();
    iop.emit('tx', this.index);
  }
}


